import React, { useEffect, useState } from "react";
import Select from "react-select-v2";
import { css } from "styled-components/macro";
import { Loading } from "../UI/general";
import fetchModule from "../../utils/fetchingData";
import { createSendForm } from "../../utils/form";
import API from "./../../configs/API";
import lstool from "../../utils/localStorage";
export default function GetCity({ setCity, AutoGenerate, getNumber }) {
  let [cities, setCityList] = useState(null);
  let [defaultCity, setDefaultCity] = useState(null);
  const getCity = async () => {
    const city = lstool.get("chosenCity")
      ? JSON.parse(lstool.get("chosenCity"))
      : null;
    let response = await fetchModule.post(
      "",
      createSendForm({ type: API.getCities }, false, "multiPart")
    );
    if (city) {
      response.forEach(item => {
        if (item.ShahrestanID == city.value) {
          setCity(city);
          setDefaultCity(city);
          AutoGenerate();
        }
      });
    }
    setCityList(response);
  };
  useEffect(() => {
    getCity();
  }, []);
  return cities ? (
    <div
      css={css`
        flex: 0 0 100%;
      `}
    >
      {typeof cities === "object" ? (
        <Select
          options={cities.map(item => ({
            label: item.ShahrestanName,
            value: item.ShahrestanID
          }))}
          onChange={value => {
            let cit;
            cities.forEach(item => {
              if (item.ShahrestanID === value.value) {
                cit = { ...value, state: item.OstanID };
              }
            });
            lstool.set("chosenCity", JSON.stringify(cit));
            setCity(value);
            getNumber();
          }}
          defaultValue={defaultCity}
          isRtl={true}
          placeholder="شهر موردنظر رو انتخاب کنید"
          isSearchable={false}
          styles={{
            container: prev => ({ ...prev, width: "100%" })
          }}
        ></Select>
      ) : (
        <p>{cities}</p>
      )}
    </div>
  ) : (
    <Loading></Loading>
  );
}
